module.exports = __webpack_public_path__ + "static/media/FFF-QUICK.72a59fa4.png";